if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
if(!window.GS.Toolbar.Frame) GS.Toolbar.Frame={};
(function(){
    var f = new Class({
        Extends: GS.Toolbar.Tools,
        class_name:'GS.Toolbar.Frame.SettingsTools',
        options:{
            'wrapper': null,
            'class':'submenu full',
            'lexico':{'w':'Width','o':'Opacity'},
            'toolbar':null
        },
        controlled:null,
        initialize:function(conf){
           this.options.lexico=Locale.get('Toolbar.settingstools');
           this.parent(conf);
           //console.debug(this.sm, this);
        }
    });

    f.prototype.updatePermissions=function(p){
        try{
            var d=(p.settings) ? 'block' : 'none';
            var s=(p.settings) ? 1 : 0;
            this.options.wrapper.setStyle('display',d);
            this.options.wrapper.store('status',1);
            if(s) this.toolbar.fireEvent('show');
        }catch(err){}
    };
    /**
     *  Link with toolbar wrapper.....
     **/

    f.prototype.menuTMPL=function(){

        var out = '';
        /*out+= '<li data-type="remove-border" title="{removeborder_title}"><label>{removeborder}</label></li>';
        out+= '<li data-type="apply-border-onpage" title="{applyborderonpage_title}"><label>{applyborderonpage}</label></li>';
        out+= '<li data-type="apply-border-ondoc" title="{applyborderondocument_title}"><label>{applyborderondocument}</label></li>';
        out+= '<li data-type="remove-border-onpage" title="{removeborderondonpage_title}"><label>{removeborderondonpage}</label></li>';

        out +='<li class="separator-h"></li>';*/
        out+= '<li class="remove-mask" data-type="remove-mask" title="{removemask_title}"><label>{removemask}</label></li>'
        out +='<li class="remove-frame" data-type="remove-frame" title="{removeframe_title}"><label>{removeframe}</label></li>'
        out +='<li class="separator-h"></li>';
        out +='<li class="remove-frame" data-type="remove-all-effects" title="{removeframe_title}"><label>{resetalleffects}</label></li>'
        /*out +='<li class="separator-h"></li>';
        out +='<li class="set-as-leftbackground" data-type="set-as-leftbackground" style="display: none;" title="{leftbackground_title}"><label>{leftbackground}</label></li>';
        out +='<li class="separator-h"></li>';
        out +='<li class="set-as-rightbackground" data-type="set-as-rightbackground"  style="display: none;" title="{rightbackground_title}"><label>{rightbackground}</label></li>';
        out +='<li class="separator-h"></li>';
        out +='<li class="set-as-fullbackground" data-type="set-as-fullbackground"  style="display: none;" title="{fullbackground_title}"><label>{fullbackground}</label></li>';*/



        return out;
    };
    
    this.SettingsTools = f;
            
            
}.call(this.GS.Toolbar.Frame));